var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVieunite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 146",
    style: {
      enableBackground: "new 0 0 800.8 451.9"
    },
    xmlSpace: "preserve",
    focusable: "false",
    "data-icon": "zoom-in",
    width: "1.1em",
    height: "1.1em",
    fill: "#FFFFFF",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stlg0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stlg0",
    d: "M423.1,435.3c0,0-397-319.2-404.9-325.7c-19.3-15-24.4-45.3-9.7-63.4c27.9-34.4,62.3-9.7,79.5,5.4 c14.1,12.3,325.7,260.1,325.7,260.1V66.6c0-15-4.3-66.6,53.7-66.6h196.7c77,0,139.7,59.1,136.5,141.9v264.4 c-0.9,25.4-21.5,44.1-46.2,45.1c-26.4-0.9-44.1-26.3-44.1-45.1V138.7c0-27.2-15.8-49.4-59.1-49.4H502.9V402 c0,13.5-3.8,30.3-15.8,40C457.8,467.5,423.1,435.3,423.1,435.3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieunite);
export default __webpack_public_path__ + "static/media/Vieunite.c065885774f18d4b1a4d8c73f5a319ff.svg";
export { ForwardRef as ReactComponent };